import { render, staticRenderFns } from "./EventTypeDialogDataTabComponent.vue?vue&type=template&id=88065db0&scoped=true"
import script from "./EventTypeDialogDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./EventTypeDialogDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./EventTypeDialogDataTabComponent.vue?vue&type=style&index=0&id=88065db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88065db0",
  null
  
)

export default component.exports